import DB from '../../DAL/DB'

export default async function generateProjectShell(projectType) {
  const intake = JSON.parse(JSON.stringify(projectType))
  try {
    const formSection = new DB.FormSection(projectType.id)
    const {ok, data: sectionsArrayRaw } = await formSection.get()

    if (!ok) {
      throw new Error('problem getting form sections')
      // return intake
    }

    
    let sectionsArray 
    if (projectType.order && Array.isArray(projectType.order) && projectType.order.length) {
       sectionsArray = sectionsArrayRaw.filter(obj => projectType.order.includes(obj.id));
    }
    else {
        sectionsArray = [...sectionsArrayRaw]
    }
      
    //console.log('sectionsArrayRaw.length',sectionsArrayRaw.length)
    //console.log('sectionsArray.length',sectionsArray.length)

    const sections = {}
    const promises = sectionsArray.map((section) => {
      const formField = new DB.FormField(projectType.id, section.id)
      return formField.get().then(({ok, data: fields}) => {
        if (ok) section.fields = fields
        sections[section.id] = section
      })
    })

    await Promise.all(promises)
    intake.sections = sections

    return intake
  } catch (e) {
    console.log(`error in generateProjectShell`, e)
  }
}
